import { useMemo } from 'react';
import type { SelectOption } from '../simple-select';

export function useSelectOptions(options: SelectOption[]) {
  return useMemo(() => {
    const optionMap = new Map(options.map((opt) => [opt.value, opt.label]));
    const labelToValueMap = new Map(options.map((opt) => [opt.label, opt.value]));
    const labelToKeywordsMap = new Map(options.map((opt) => [opt.label, opt.keywords]));
    const items = options.map((opt) => opt.label);

    return {
      optionMap,
      labelToValueMap,
      items,
      getLabel: (value?: string) => (value ? optionMap.get(value) || null : null),
      getValue: (label: string) => labelToValueMap.get(label),
      getKeywords: (label: string) => labelToKeywordsMap.get(label),
      getLabels: (values: string[]) => values.map((v) => optionMap.get(v)).filter(Boolean) as string[],
      getValues: (labels: string[]) => labels.map((label) => labelToValueMap.get(label)).filter(Boolean) as string[]
    };
  }, [options]);
}
